import React, { Component } from "react";
import { getSalary, updateSalaryDetail } from "../../services/salaryService";
import { Table, Grid, Confirm, Button } from "semantic-ui-react";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Link } from "react-router-dom";
import TableTitle from "../common/tableTitle";

class SalaryDetail extends Component {
  state = {
    salary: { salary_detail: [] },
    blocking: false,
    open: false,
    result: "",
    content: "",
    data: {
      visaId: "",
      workDate: "",
      projectId: "",
      hours: "",
      salaryDetailId: "",
      personName: "",
      newHour: "",
    },
  };

  async getSalaryDetail(salaryId) {
    try {
      const { data: salary } = await getSalary(salaryId);

      this.setState({ salary, blocking: false });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  show = () => this.setState({ open: true });
  handleConfirm = async () => {
    this.setState({ open: false, blocking: true });
    const verifyData = {
      visaId: this.state.data.visaId,
      workDate: this.state.data.workDate,
      projectId: this.state.data.projectId,
      hours: this.state.data.hours,
      salaryDetailId: this.state.data.salaryDetailId,
      personNames: this.state.data.personNames,
      newHour: this.state.data.newHour,
      _method: "PUT",
    };

    try {
      await updateSalaryDetail(verifyData);

      const salaryId = this.props.match.params.id;
      this.getSalaryDetail(salaryId);
      this.setState({ blocking: false });

      toast.success("Entry has been updated successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        toast.warning("Hours should be only numbers");
      }
    }
  };

  handleCancel = () => this.setState({ result: "cancelled", open: false });

  componentDidMount() {
    this.setState({ blocking: true });
    const salaryId = this.props.match.params.id;
    this.getSalaryDetail(salaryId);
  }

  confirmSalary = async (
    visaId,
    workDate,
    projectId = "",
    hours,
    salaryDetailId,
    personNames
  ) => {
    this.setState({ blocking: true });
    const hour = document.getElementById(salaryDetailId).value;

    if (hour == "") {
      toast.warning("Please enter hours to continue.");
      this.setState({ blocking: false });
      return false;
    }

    // if (isNaN(hour)) {
    //   toast.warning("Hours will be numeric only.");
    //   this.setState({ blocking: false });
    //   return false;
    // }

    if (hour == "0") {
      this.show();
      this.setState({
        content:
          "Are you sure, you want to remove " +
          hours +
          " hours of " +
          personNames +
          ".",
      });
    }

    if (hour != "0" && hour != "") {
      this.show();
      this.setState({
        content:
          "Are you sure, you want to update " +
          hours +
          " hours with " +
          hour +
          " of " +
          personNames +
          ".",
      });
    }

    this.setState({
      data: {
        visaId,
        workDate,
        projectId,
        hours,
        salaryDetailId,
        personNames,
        newHour: hour,
      },
      blocking: false,
    });

    // var event = new Date(this.state.salaryDate);
    // let date = JSON.stringify(event);
    // date = date.slice(1, 11);
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.open}
          content={this.state.content}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />

        <h1 class="container__heading">Salary detail</h1>

        <Grid columns={1} divided>
          <Grid.Row>
            <Grid.Column>
              <center>
                {/* <Table definition>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell width={8}>Work Date</Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={8}></Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table> */}

                <div className="error form">
                  <Table celled singleLine>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell width={1}>Id</Table.HeaderCell>
                        <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                        <Table.HeaderCell width={3}>Mobile</Table.HeaderCell>
                        <Table.HeaderCell width={4}>Company</Table.HeaderCell>
                        <Table.HeaderCell
                          width={5}
                          style={{ whiteSpace: "pre-line" }}
                        >
                          Project
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1}>Hours</Table.HeaderCell>
                        <Table.HeaderCell width={2}>New Hours</Table.HeaderCell>
                        <Table.HeaderCell width={1}></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {this.state.salary.salary_detail.map((entry) => (
                        <Table.Row key={entry.id}>
                          <Table.Cell>
                            {entry.visa ? entry.visa.id : ""}
                          </Table.Cell>
                          <Table.Cell style={{ whiteSpace: "pre-line" }}>
                            {entry.visa ? entry.visa.name : ""}
                          </Table.Cell>

                          <Table.Cell>
                            {entry.visa ? entry.visa.mobile : ""}
                          </Table.Cell>

                          <Table.Cell style={{ whiteSpace: "pre-line" }}>
                            {entry.visa ? entry.visa.company.name : ""}
                          </Table.Cell>
                          <Table.Cell style={{ whiteSpace: "pre-line" }}>
                            {entry.project ? entry.project.company_name : ""}
                          </Table.Cell>
                          <Table.Cell>
                            {entry.attendance == "P" ? entry.hours : ""}
                            {entry.attendance == "A" ? "Absent" : ""}
                            {entry.attendance == "L" ? "Leave" : ""}
                          </Table.Cell>
                          <Table.Cell>
                            <input
                              maxlength="4"
                              type="text"
                              className="input"
                              id={entry.id}
                            />
                          </Table.Cell>
                          <Table.Cell>
                            <button
                              className="btn btn--primary"
                              onClick={() =>
                                this.confirmSalary(
                                  entry.visa_id,
                                  this.state.salary.work_date,
                                  entry.project_id,
                                  entry.hours,
                                  entry.id,
                                  entry.visa.name
                                )
                              }
                            >
                              Confirm
                            </button>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>
              </center>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </BlockUi>
    );
  }
}

export default SalaryDetail;
